import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const FooterThree = () => {
  const location = useLocation();
  const [logo, setLogo] = useState('/assets/img/logo/lumetiq_logo.png');
  const [num, setNum] = useState("(+91) 95741 00028");

  // 2. Use the useEffect hook to safely update state when the URL changes.
  useEffect(() => {
    const path = location.pathname.toLowerCase();

    if (path.includes("/fire")) {
      setNum("(+91) 94295 71520");
      setLogo("/assets/img/bg/fire.jpg");
    } else if (path.includes("/green")) {
      setNum("(+91) 95741 00026");
      setLogo("/assets/img/bg/green.jpg");
    } else {
      setNum("(+91) 95741 00028");
      setLogo("/assets/img/logo/lumetiq_logo.png");
    }
    // This effect will re-run every time the `location` object changes.
  }, [location]);

  // 3. Create a clean, clickable telephone link from the `num` state.
  // The 'tel:' protocol needs a clean number without spaces or parentheses.
  const telLink = `tel:${num.replace(/[()\s-]/g, '')}`;
  const getLogoLinkFromPath = () => {

    const path = location.pathname.toLowerCase();

    if (path.includes("/fire")) {
      return "/fire";
    } else if (path.includes("/green")) {
      return "/green";
    }
    return "/";
  };
  return (
    <footer>
      <div className="tp-footer__area white-bg">
        <div className="tp-footer">
          {/* <!-- main-footer start  --> */}
          <div className="tp-footer__main">
            <div className="container">
              <div className="tp-footer-border pt-100 pb-70">
                <div className="pb-30 pb-70">
                  <div className="row align-items-center tp-footer-top-row">
                    <div className="col-12 col-md-6">
                      <div className="footer-logo mb-30">
                        <Link to={getLogoLinkFromPath()}><img src={logo} style={{ height: location.pathname.toLowerCase().includes("/green") || location.pathname.toLowerCase().includes("/fire") ? "110px" : "80px", width: "auto", objectFit: "contain" }} alt="Lumetiq Logo" /></Link>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 text-end ">
                      <div className="footer-form-2 mb-30 ">
                        <form>
                          <input type="email" className=" border-dark " placeholder="Enter your mail" />
                          <button type="submit" className="text-black ">Subscribe <i
                            className="fal fa-paper-plane"></i></button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row" style={{display:'flex',justifyContent:'space-evenly'}}>
                  {/* <div className="col-lg-3 col-md-6">
                    <div className="tp-footer__widget tp-footer__2 pb-30">
                      <h3 className="tp-footer__widget-title text-black">Our Location</h3>
                      <ul>
                        <li><a href="#">London</a></li>
                        <li><a href="#">America</a></li>
                        <li><a href="#">Constarica</a></li>
                        <li><a href="#">Germany</a></li>
                        <li><a href="#">India</a></li>
                      </ul>
                    </div>
                  </div> */}
                  <div className="col-lg-3 col-md-6">
                    <div className="tp-footer__widget tp-footer__2 pb-30">
                      <h3 className="tp-footer__widget-title text-black">Our Service</h3>
                      <ul>
                        <li><a href="/new-installation">New Lift Installation</a></li>
                        <li><a href="/maintenance-contract">Maintenance Contract</a></li>
                        <li><a href="/modification">Modification</a></li>
                        <li><a href="/repair-and-service">Repair and Service</a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 ">
                    <div className="tp-footer__widget tp-footer__2  pb-30">
                      <h3 className="tp-footer__widget-title text-black">Quick Links</h3>
                      <ul>
                        {/* <li><a href="/team">Our Team</a></li> */}
                        <li><a href="/faq">Faq</a></li>
                        {/* <li><a href="/portfolio">Portfolio</a></li> */}
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/service">Services</a></li>
                        <li><a href="/contact">Contact Us</a></li>
                        <li><a href="/contact">Career </a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="tp-footer__widget tp-footer__2  pb-30">
                      <h3 className="tp-footer__widget-title text-black">Our Contact</h3>
                      <ul>
                        <li><a href="#">LUMETIQ INFRA, <br />
                          2106, 21st floor, wings business bay,
150 Feet Ring Rd, beside fortune hotel,
Rajkot, Gujarat, India</a></li>
                        <li><a href={telLink}>{num}</a></li>
                        <li><a href="mailto:Info@lumetiq.in">Info@lumetiq.in</a></li>
                        <li><span> Office Hours: 9AM - 7PM</span></li>
                        <li><span> Sunday - Weekend Day</span></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- main footer end  --> */}
        </div>
      </div>

      {/* <!-- footer copy right --> */}
      <div className="top-footer-copyright pt-30 pb-30">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="tp-copyrigh-text text-center text-black">
                <span>© {new Date().getFullYear()} Lumetiq Elevators . All Rights Reserved..</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- footer copyright end  --> */}
    </footer>
  );
};

export default FooterThree;